import { render, staticRenderFns } from "./PartnerTokenList.vue?vue&type=template&id=33e2b622&"
import script from "./PartnerTokenList.vue?vue&type=script&lang=js&"
export * from "./PartnerTokenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports